// extracted by mini-css-extract-plugin
module.exports = {"header":"ResultPage_header__gxgt6","content":"ResultPage_content__TAyKe"};